'use strict';
var parent = require('../../actual/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/keys.js
// module id = 366
// module chunks = 0